import { styled, Stack } from "@mui/material";

export const DownloadButtonWrapper = styled(Stack)({
  flexWrap: "wrap",
  gap: "6px",
  maxWidth: "220px"
});
